import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/5 py-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-zinc-600 text-xs">
          &copy; {new Date().getFullYear()} AppoinText AI. All rights reserved.
        </p>
        <Link to="/privacy" className="text-zinc-600 hover:text-zinc-400 text-xs transition-colors">
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
}
